import { useEffect } from "react";

// Immediately sends the visitor to an external URL (outside the app router).
const ExternalRedirect = ({ to }) => {
	useEffect(() => {
		window.location.href = to;
	}, [to]);

	return null;
};

export default ExternalRedirect;
